<ion-item class="ion-no-padding" lines="full">
    <ion-button (click)="apply()" color="primary" fill="outline" slot="start">Apply</ion-button>
    <ion-label>{{ filter?.name }}</ion-label>
    <ion-button (click)="delete()" color="danger" fill="outline" slot="end">Delete </ion-button>
</ion-item>